import { FC, useState } from "react";
import { Grade, SeoItem, SeoOptimization } from "../types";
import { Accordion } from "react-bootstrap";
import { getPageTitle } from "../util";


type Props = {
  seoOptimization: SeoOptimization;
  content: string;
  metaDescription: string;
};
const getColor = (grade: Grade) => {
  if (grade == "Excellent") return "green";
  if (grade == "Good") return "orange";
  if (grade == "Poor") return "red";
  return "red";
};

export const SeoOptimisationTabContent: FC<Props> = ({ seoOptimization, content, metaDescription }) => {

  const [activeKey, setActiveKey] = useState<string | null>(null);


  return (
    <div>
      <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key as string)}>
        {seoOptimization.sections.map((section, index) => (
          <Accordion.Item key={section.key} eventKey={section.key}>
            <Accordion.Header>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h5 style={{ margin: 2 }}>{section.title}</h5>
                <span
                  style={{
                    marginLeft: "auto",
                    color: "#212529",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginRight: "10px",
                  }}
                >
                  <span>Score: {section.sectionScore}</span>
                </span>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              <ul style={{ listStyle: "none", padding: 5 }}>
                {section.seoItems.map((scoreDetail: SeoItem, idx) => {
                  return (
                    <li
                      key={idx}
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        marginBottom: "12px",
                      }}
                    >
                      <span
                        style={{
                          flexShrink: 0,
                          width: "15px",
                          height: "15px",
                          backgroundColor: getColor(scoreDetail.grade),
                          borderRadius: "20%",
                          display: "inline-block",
                          marginRight: "10px",
                          marginTop: "7px",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                          border: "1px solid white",
                        }}
                      ></span>
                      <span
                        style={{
                          color: "#605353",
                          lineHeight: "1.5",
                        }}
                      >
                        {scoreDetail.text}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </Accordion.Body>
          </Accordion.Item>

        ))
        }</Accordion>

    </div >
  );
};
